<template>
  <div class="layout">
    <LoadingIndicator v-if="busy" />
    <div v-else-if="nodata" class="no-data">
      <span>表示する内容がありません</span>
    </div>
    <template v-else>
      <div class="v-axis-unit">
        <slot name="v-axis-unit" />
      </div>
      <div class="top">
        <slot name="top" />
      </div>
      <div class="top-right">
        <slot name="top-right" />
      </div>
      <div class="graph">
        <slot />
      </div>
      <div class="h-axis-unit">
        <slot name="h-axis-unit" />
      </div>
      <div class="bottom-left">
        <slot name="bottom-left" />
      </div>
      <div class="year-labels">
        <slot name="year-labels" />
      </div>
      <div class="bottom-right">
        <slot name="bottom-right" />
      </div>
    </template>
  </div>
</template>

<script>
import LoadingIndicator from '@/components/molecules/LoadingIndicator'

export default {
  name: 'FrameTemplate',
  components: {
    LoadingIndicator,
  },
  props: {
    busy: {
      type: Boolean,
      required: false,
      default: false,
    },
    nodata: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style lang="postcss" scoped>
.layout {
  display: grid;
  grid-template-columns: 48px 1fr 32px;
  grid-template-rows: 18px 1fr 16px;
  height: 372px;
  width: 100%;

  .graph {
    grid-column: 1 / 3;
  }

  .v-axis-unit,
  .h-axis-unit {
    align-items: flex-end;
    display: flex;
    font-size: 11px;
  }

  .v-axis-unit {
    flex-direction: column;
    margin: 0 9px 4px 0;
  }
  .h-axis-unit {
    margin: 0 0 3px 3px;
  }

  .no-data {
    align-items: center;
    display: flex;
    font-size: 14px;
    grid-column: 1 / 4;
    grid-row: 1 / 4;
    justify-content: center;
    line-height: 1.7;
    text-align: center;
  }
}
</style>
